import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
//import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { ErrorInterceptor } from './intercepter/error.interceptor';
import { JwtInterceptor } from './intercepter/jwt.interceptor';

//TODO: refresh issue when page load login page is displayed
/*
export function appInitializer(authService: AuthenticationService): () => Promise<void> {
    return () =>
        new Promise((resolve) => {
            authService.checkAuthenticationState().then(() => {
                resolve();
            });
        });
}*/

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        //provideAnimationsAsync(),
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi()
        ),
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        provideAnimations(), // required animations providers
        provideToastr({ //Add global toastr configuration
            timeOut: 4000,
            extendedTimeOut: 3000,
            closeButton: true,
            enableHtml: true,
            progressBar: true,
            preventDuplicates: true,
            positionClass: 'toast-top-right',
        }),
        // {
        //     provide: 'APP_INITIALIZER',
        //     useFactory: appInitializer,
        //     deps: [AuthenticationService],
        //     multi: true,
        // },
        //{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        //{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    ]
};